import React, { useEffect, useState } from "react";
import "./App.scss";
import RouterIndex from "./router/RouterIndex";
import Loader from "./Loader/Loader";
import Modal from "react-bootstrap/Modal";
import waringimg from "./assests/images/warning-image.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
function App() {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1200);
  }, []);

  const token = sessionStorage.getItem("access-user-token");

  useEffect(() => {
    if (token) {
      if (window.location.pathname == "/") {
        window.location.assign("/dashboard");
      }
    } else {
    }
  }, []);
  const navigate = useNavigate();

  useEffect(() => {
    window.addEventListener("online", function () {
      navigate("/dashboard");
    });
    window.addEventListener("offline", function () {
      navigate("/offline");
    });
  }, []);

  return loading ? (
    <>
      <div className="loader-sections">
        <Loader />
      </div>
    </>
  ) : (
    <>
      <div className="App">
        <RouterIndex />
      </div>
    </>
  );
}

export default App;
